/**
 * Labels for a plain yes/no filter; values are the strings the API reads.
 * Lives apart from the control so filter contracts can share it without
 * importing React.
 */
export const BOOLEAN_FILTER_OPTIONS = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
] as const;
